import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type { ExperimentRunsResponse, RunListItemResponse, RunListResponse } from '@/entities/experiment';

export const getExperimentRuns = async (experimentId: string): Promise<ExperimentRunsResponse> => {
  try {
    const response = await cycloneApiClient.get<RunListResponse>('/runs', {
      params: {
        experimentId: Number(experimentId),
        page: 1,
        size: 100,
      },
    });

    const runs = response.data.runs.map((run: RunListItemResponse) => ({
      id: String(run.id),
      name: run.name,
      description: run.description,
      status: run.status,
      startTime: run.createdAt,
    }));

    return { runs };
  } catch (error) {
    console.warn(`Failed to fetch runs for experiment ${experimentId}:`, error);
    return { runs: [] };
  }
};
